import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Image from "next/image"
import Link from "next/link"
import { Fragment } from "react"
import { getCanonicalSlug, productLink } from "@components/config/helpers"

const ProductVariants = ({product_id, product_variants}) => {
    return (
        <>
            <Typography color="grey" className="mt-3 mb-2 f-size_4">Product Variants</Typography>
            <Box sx={{
                overflowX: {
                    xs: 'auto',
                    lg: 'inherit'
                },
               
            }} className="d-flex">
                {product_variants.map((variant, idx) => {
                    const urlLink = getCanonicalSlug({canonical_category_slug: variant.canonical_category_slug, section_slug: variant.section_slug});

                    return (
                        <Fragment key={idx}>
                            
                            <Box 
                            className="pr-1"
                     
                            >
                                <Box 
                                className={`mr-2  ${ product_id !== variant.product_variant_product_id  &&  'hover-underline-product'}`}
                                 sx={{ marginBottom:  variant.product_id && product_id === variant.product_variant_product_id && '3px',
                                  border:  variant.product_id && product_id === variant.product_variant_product_id ? '2px solid var(--color-primary)' : 'unset', }}>
                                <Link shallow={true} className="d-flex mb-0 pb-0" href={productLink(urlLink, variant.product_slug)} passHref>
                                    <Image className='mb-0 pb-0' style={{
                                        cursor: 'pointer',

                                    }} 
                                    blurDataURL={variant.cart_image} placeholder="blur" src={variant.cart_image} alt={variant.product_name} height={60} width={60} quality={100}/>
                                </Link>
                                </Box>
                                <Box className='pt-0 mt-0'>
                                    {/* <p>{variant.product_variant_label}</p> */}
                                <Typography className="d-block text-center mt-0 pt-0" component="small" variant="small">{variant.product_variant_label}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                        )
                    })}
            </Box>
        </>
    )
}

export default ProductVariants